// extracted by mini-css-extract-plugin
module.exports = {"reference-type-switch":"a58AbYn2bQ7DX_P9SrQJ"};